<!-- <mat-card> -->
@if (title.length || subtitle.length) {
<mat-card-header>
  <mat-card-title>
    <mat-icon color="warn"
              class="alert_icon">warning</mat-icon>
  </mat-card-title>

  @if (title.length) {
  <mat-card-title>{{title}}</mat-card-title>
  }
  @if (subtitle.length) {
  <mat-card-subtitle>{{subtitle}}</mat-card-subtitle>
  }

</mat-card-header>
}
<mat-card-content>
  <mat-dialog-content>
    <p>{{msg}}</p>

    @if (msg2.length) {
    <div>
      {{msg2}}
    </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="gap-32">
    <button mat-raised-button
            color="{{colorNo}}"
            [mat-dialog-close]="false">No</button>
    <button mat-raised-button
            color="{{colorYes}}"
            [mat-dialog-close]="true">Si</button>
  </mat-dialog-actions>
</mat-card-content>
<!-- </mat-card> -->